import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiCpu,
    title: "System Architecture",
    description: "Designing scalable, resilient, and highly available distributed systems built to withstand enterprise-grade operational demands."
  },
  {
    icon: FiIcons.FiCommand,
    title: "AI & ML Integration",
    description: "Embedding predictive models and LLMs directly into the product core to automate complex workflows and generate unique insights."
  },
  {
    icon: FiIcons.FiLayers,
    title: "Full-Stack Engineering",
    description: "Zero-compromise execution from the data persistence layer up to highly polished, interactive user interfaces."
  },
  {
    icon: FiIcons.FiShield,
    title: "Security & Compliance",
    description: "Architecting systems with zero-trust principles, ensuring data integrity and regulatory compliance from day one."
  }
];

const Capabilities = () => {
  return (
    <section id="expertise" className="py-32 relative border-t border-zinc-900 bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-20 md:w-2/3">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter mb-6">Engineering Excellence</h2>
          <p className="text-zinc-400 text-lg font-light leading-relaxed">
            We don't just write code; we architect solutions. Our approach ensures that every layer of your application is optimized for performance, scalability, and intelligence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-black p-10 lg:p-16 group hover:bg-zinc-900/20 transition-colors"
            >
              <div className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center mb-8 text-cyan-400 group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="text-xl" />
              </div>
              <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
              <p className="text-zinc-500 leading-relaxed font-light">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;